//src/utils/apiHelper.js
import API from "../api";

export const getDecks = async () => {
  try {
    const url = "/flashcards/decks";
    console.log("🌐 GET Request URL:", API.defaults.baseURL + url);

    const res = await API.get(url);

    console.log("✅ Response status:", res.status);
    console.log("✅ Response data:", res.data);

    return res.data;
  } catch (err) {
    console.error("❌ Error fetching decks (apiHelper):", err);
    if (err.response) {
      console.error("💥 Backend response:", err.response.data);
    }
    return [];
  }
};


// ✅ Get all flashcards in a deck
export const getFlashcardsByDeck = async (deckId) => {
  try {
    console.log(`🌐 Fetching flashcards for deck: ${deckId}`);
    const res = await API.get(`/flashcards/deck/${deckId}`);
    console.log("✅ Flashcards fetched:", res.data);
    return res.data;
  } catch (err) {
    console.error("❌ Error fetching flashcards:", err);
    return [];
  }
};

// ✅ Add new flashcard
export const addFlashcard = async (data) => {
  try {
    const res = await API.post("/flashcards/add", data);
    console.log("🟢 Flashcard added:", res.data);
    return res.data;
  } catch (err) {
    console.error("❌ Error adding flashcard:", err);
    throw err;
  }
};
